export default __webpack_public_path__ + "4846aeb7c5b88dbf211e6a35a15ff401.jpg";